export default function LoadingUserDetail() {
  return (
    <main className='w-full mx-auto animate-pulse px-6'>
      <div className='flex gap-2 items-center my-5'>
        <span className='h-20 w-20 rounded-full bg-neutralColor-light block'></span>
        <div className='space-y-2'>
          <span className='h-2 rounded-md bg-neutralColor-light w-32 block'></span>
          <span className='h-2 rounded-md bg-neutralColor-light w-20 block'></span>
        </div>
      </div>
      <div className='border-t border-gray-200 space-y-12 pt-5'>
        {Array.from(Array(8).keys()).map((_num, index) => (
          <div key={index} className='flex'>
            <div className='w-1/3'>
              <div className='h-2 w-1/4 bg-neutralColor-light rounded-full'></div>
            </div>
            <div className='h-2 w-1/5 bg-neutralColor-light rounded-full'></div>
          </div>
        ))}
        <div className='bg-white border-t'></div>
      </div>
    </main>
  );
}
